import React from 'react';
import {
  Switch,
  ListItemButton,
  ListItemText,
  ListSubheader,
  ListItemSecondaryAction,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { useSectionsProgressContext } from 'contexts/SectionsProgressContext';
import { useFormStateContext } from 'contexts/FormStateContext';
import useEnableSectionsProgressLogging from 'hooks/sectionsProgress/useEnableSectionsProgressLogging';
import useEnableFormStateLogging from 'hooks/affordaPortalFormState/useEnableFormStateLogging';
import useEnableAllSections from 'hooks/dev/useEnableAllSections';
import useCompleteDocumentsAndUploadsTaskList from 'hooks/dev/useCompleteDocumentsAndUploadsTaskList';

const DevControls = () => {
  const { deleteSectionsProgress } = useSectionsProgressContext();
  const { deleteForm } = useFormStateContext();
  const {
    isSectionsProgressLoggingEnabled,
    toggleIsSectionsProgressLoggingEnabled,
  } = useEnableSectionsProgressLogging();
  const { isFormStateLoggingEnabled, toggleIsFormStateLoggingEnabled } =
    useEnableFormStateLogging();
  const { allSectionsEnabled, toggleAllSectionsEnabled } =
    useEnableAllSections();
  const {
    completeDocumentsAndUploadsTaskList,
    toggleCompleteDocumentsAndUploadsTaskList,
  } = useCompleteDocumentsAndUploadsTaskList();

  return (
    <>
      <ListSubheader sx={{ marginTop: 4, backgroundColor: 'transparent' }}>
        Dev Controls
      </ListSubheader>
      <ListItemButton onClick={deleteSectionsProgress}>
        <ListItemText primary={'Delete Sections Progress'} />
      </ListItemButton>
      <ListItemButton onClick={deleteForm}>
        <ListItemText primary={'Delete Form Data'} />
      </ListItemButton>
      <ListItemButton onClick={toggleIsSectionsProgressLoggingEnabled}>
        <ListItemText primary={'Sections Progress Logging'} />
        <ListItemSecondaryAction
          sx={{ position: 'relative', top: 'unset', transform: 'none' }}
        >
          <Switch checked={isSectionsProgressLoggingEnabled} />
        </ListItemSecondaryAction>
      </ListItemButton>
      <ListItemButton onClick={toggleIsFormStateLoggingEnabled}>
        <ListItemText primary={'Form State Logging'} />
        <ListItemSecondaryAction
          sx={{ position: 'relative', top: 'unset', transform: 'none' }}
        >
          <Switch checked={isFormStateLoggingEnabled} />
        </ListItemSecondaryAction>
      </ListItemButton>
      <ListItemButton onClick={toggleAllSectionsEnabled}>
        <ListItemText primary={'Enable All Sections'} />
        <ListItemSecondaryAction
          sx={{ position: 'relative', top: 'unset', transform: 'none' }}
        >
          <Switch checked={allSectionsEnabled} />
        </ListItemSecondaryAction>
      </ListItemButton>
      <ListItemButton onClick={toggleCompleteDocumentsAndUploadsTaskList}>
        <ListItemText
          primary={'Enable TaskList Continue'}
          secondary={'Documents And Uploads'}
        />
        <ListItemSecondaryAction
          sx={{ position: 'relative', top: 'unset', transform: 'none' }}
        >
          <Switch checked={completeDocumentsAndUploadsTaskList} />
        </ListItemSecondaryAction>
      </ListItemButton>
      <ListItemButton onClick={() => localStorage.clear()}>
        <ListItemText primary={'Clear Local Storage'} />
      </ListItemButton>
    </>
  );
};

export default DevControls;
